import * as React from "react"
import { Center, Box } from "@chakra-ui/react"
import { activeSpeakerSelector } from "../../recoil/atoms/activeSpeaker"
import { useRecoilValue } from "recoil"
import MediaPlayer from "./_mediaPlayer"
import layoutStates from "../../recoil/atoms/layout"
import { watchPartyScreenSelector } from "../../recoil/atoms/watchPartyScreen"

export interface PrevSpeakerStyles {
  highlighterColor: string
  alertBackgroundColor: string
}

interface PrevSpeakerStreamsProps {
  maxWidthScreen?: number
  heightPrevSpeaker?: number
  localUserProperties: any
  userIdsSmallWindows: string[]
  roomStylesPrevSpeaker: PrevSpeakerStyles
}

export const _PrevSpeakerStreams: React.FC<PrevSpeakerStreamsProps> = ({
  maxWidthScreen,
  heightPrevSpeaker,
  localUserProperties,
  userIdsSmallWindows,
  roomStylesPrevSpeaker
}) => {
  const smallScreenWidth = React.useMemo(
    () => (heightPrevSpeaker * 16) / 9,
    [heightPrevSpeaker]
  )

  const activeSpeaker = useRecoilValue(activeSpeakerSelector)
  const gridViewEnabled = useRecoilValue(layoutStates.gridViewEnabled)

  const isWatchParty = useRecoilValue(watchPartyScreenSelector)
  const _stylingWithBorder: React.CSSProperties = React.useMemo(() => {
    return {
      aspectRatio: "unset",
      border: "2px solid",
      borderColor: roomStylesPrevSpeaker?.highlighterColor ?? "#000000",
      maxWidth: smallScreenWidth,
      height: "100%",
      maxHeight: heightPrevSpeaker,
      backgroundColor:
        roomStylesPrevSpeaker?.alertBackgroundColor !== ""
          ? roomStylesPrevSpeaker?.alertBackgroundColor
          : "black"
    }
  }, [
    heightPrevSpeaker,
    roomStylesPrevSpeaker?.alertBackgroundColor,
    roomStylesPrevSpeaker?.highlighterColor,
    smallScreenWidth
  ])
  const _stylingWithoutBorder: React.CSSProperties = React.useMemo(() => {
    return {
      aspectRatio: "unset",
      maxWidth: smallScreenWidth,
      height: "100%",
      maxHeight: heightPrevSpeaker,
      backgroundColor:
        roomStylesPrevSpeaker?.alertBackgroundColor !== ""
          ? roomStylesPrevSpeaker?.alertBackgroundColor
          : "black"
    }
  }, [
    heightPrevSpeaker,
    roomStylesPrevSpeaker?.alertBackgroundColor,
    smallScreenWidth
  ])
  let otherUserIds: string[] = []

  return (userIdsSmallWindows.length && !gridViewEnabled) || isWatchParty ? (
    <Center
      id="remote-players"
      overflow="hidden"
      flex={1}
      maxWidth={maxWidthScreen}
    >
      {userIdsSmallWindows.map((uid, index) => {
        const marginSpecial = index === 0 ? "0 0 0 auto" : "0 auto 0 0"
        const marginDefault = "0 auto"
        if (uid) {
          return (
            <Box
              flex={1}
              key={`${uid}${index}`}
              h="100%"
              w="100%"
              marginRight="16px"
              _last={{ marginRight: "0px" }}
            >
              <Box
                maxHeight="100%"
                margin={
                  otherUserIds.length === 2 ? marginSpecial : marginDefault
                }
                position="relative"
                width={smallScreenWidth}
                height={"100%"}
              >
                <MediaPlayer
                  key={`player-${uid}`}
                  index={index}
                  uid={uid}
                  styling={
                    uid === activeSpeaker.uid
                      ? _stylingWithBorder
                      : _stylingWithoutBorder
                  }
                  isSmallWindow={true}
                  localUserProperties={
                    localUserProperties.localUserId === uid
                      ? localUserProperties
                      : {}
                  }
                />
              </Box>
            </Box>
          )
        }
        return null
      })}
    </Center>
  ) : null
}

export const PrevSpeakerStreams = React.memo(_PrevSpeakerStreams)
